import { Component, OnInit, Input, Inject, Optional } from '@angular/core';
import { ControlContainer, FormGroup, NgForm, NgModelGroup } from '@angular/forms';

import { ResponseChangedService } from '../services/responseChangedService';
import { Question } from '../shared/question'
import { Response } from '../shared/response';

import {
  ViewChild,
} from '@angular/core';

import {
  NgModel,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  NG_ASYNC_VALIDATORS,
} from '@angular/forms';


@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgModelGroup }]
  // providers: [
  //   {provide: NG_VALUE_ACCESSOR, useExisting: QuestionComponent, multi: true}
  // ]
})
export class QuestionComponent //extends ElementBase<string | boolean | number> 
  implements OnInit {

  @Input() question!: Question;
  @Input() index!: number;
  // @ViewChild(NgModel) model!: NgModel;

  // @Input() form!: NgForm;
  // formGroup !: FormGroup;

  radioSelected: number = 1;
  phrasesToHighlight: string[] = ['dispozitivul Ploom în general?', 'imaginea mărcii Ploom?', 'savoarea gustului în general?', 'miros în general?', 'ușurința utilizării dispozitivului?', 'design-ul dispozitivului?', 'execuție al accesoriilor?', 'vizitării site-ului Ploom?', 'vizitării paginii de Instagram Ploom?', 'primirii de emailuri/SMS-uri din partea Ploom?', 'achiziționărilor de pe site-ul mărcii Ploom (www.ploom.ro)?', 'contactului cu serviciul de asistență pentru clienți Ploom (soluționare problemelor, informații)?', 'participării la evenimente organizate sau sponsorizate de Ploom?', 'interacțiunii cu brand ambasadoare/ambasadori ai mărcii Ploom (sesiuni de încercare asistate, oferte speciale și informații despre produsele Ploom)?', 'achiziționărilor dintr-un magazin specializat al mărcii Ploom/O insulă Ploom din Mall?', 'serviciilor/experiențelor la magazinele/insulele Ploom din Mall (excluzând achizițiile)?', 'reclamelor Ploom online sau în afara mediului online (panouri publicitare, videoclipuri pe mașini etc.?', 'informațiilor de la vânzători în magazine (inclusiv oferte speciale și informații despre produsele Ploom)?', 'reclamelor la benzinării sau magazine/chioșcuri?', 'citirii de informații pe site-uri de știri sau forumuri pe internet?', 'vizionării unui videoclip pe YouTube?', 'interacțiunii cu un stand al mărcii Ploom la un festival?', 'observării marcii Ploom pe un afiș al unui eveniment (sponsor al evenimentului)'];
  phrasesToHighlightGreen: string[] = []

  constructor(private responseChangedService: ResponseChangedService,
    // @Optional() @Inject(NG_VALIDATORS) private validators: Array<any>,
    // @Optional() @Inject(NG_ASYNC_VALIDATORS) private asyncValidators: Array<any>
  ) {
    // super(validators, asyncValidators);
  }

  sub: any;

  ngOnInit(): void {
    // this.formGroup = this.form.form;
    this.sub = this.responseChangedService.changedResponseEvent.subscribe((questionId: number) => {
      if (this.question.subscribeToQuestions.indexOf(questionId) >= 0) {
        console.log(`observed question ${questionId} changed responses, detected by question ${this.question.id}`)
      }
    });
    if (this.question.type === 'star') {
      this.question.responses.forEach(r => r.score = 1);
    }

  }

  changedResponse(response: Response) {
    if (this.question.type.startsWith('checkbox')) {
      response.selected = !response.selected;
    }
    if (this.question.type === 'radio' || this.question.type === 'radio-inline' || this.question.type === 'radio-free') {
      this.question.responses.filter(r => r.id !== response.id).forEach(r => r.selected = false);
      response.selected = true;
    }
    console.log(`question ${this.question.id} changed response`)
    this.responseChangedService.changedResponseEvent.emit(this.question.id);

    this.lockQuestion()
  }

  lockQuestion() {
    if (this.question?.lockDisabled) {
      return;
    }
    if (this.question.type == 'radio' || this.question.type === 'radio-inline' || this.question.type == 'free-number' || this.question.type == 'free-number-warning') {
      this.question.isDisable = true;
    }
  }

  lockQuestionText(response: any) {
    if (this.question?.lockDisabled) {
      return;
    }
    if (this.question.type == 'free-number' || this.question.type == 'free-number-warning' || this.question.type == 'radio-free' || this.question.type == 'free-number-warning-reset') {
      if (response.freeMessage) {
        this.question.isDisabledText = true;
      }
    }
  }




  updateDropdown(el: HTMLSelectElement, question: Question) {
    let selectedOptionValue = el.options[el.options.selectedIndex].value;
    for (let i = 0; i < question.responses.length; i++) {
      let response = question.responses[i];
      if (response.text === selectedOptionValue) {
        response.selected = true;
      } else {
        response.selected = false;
      }
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }



  isNotInInterval(value: string, min: number, max: number): boolean {
    const numberValue = parseInt(value);
    return !isNaN(numberValue) && (numberValue < min || numberValue > max);
  }


  showWarning: boolean = false;


  // Funcția apelată la fiecare schimbare de input
  onInputChange(event: Event, response: any, min: number, max: number): void {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;

    // Verifică dacă valoarea este în afara intervalului 1-35
    if (this.isNotInInterval(value, min, max)) {
      this.showWarning = true;
      response.freeMessage = ''; // Resetăm valoarea din input
    } else {
      this.showWarning = false;
      response.freeMessage = value;
    }
  }


  highlightWords(text: string): string {
    let modifiedText = text;

    // Funcție care escape-uiește caracterele speciale dintr-o frază pentru expresia regulată
    const escapeRegExp = (string: string) => {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
    };

    // Iterează prin frazele de subliniat și le înlocuiește în text
    this.phrasesToHighlight.forEach(phrase => {
      const escapedPhrase = escapeRegExp(phrase); // Escape the phrase
      const regex = new RegExp(`(${escapedPhrase})`, 'gi'); // Căutăm fraza indiferent de majuscule/minuscule
      modifiedText = modifiedText.replace(regex, `<span class="highlight-blue">$1</span>`);
    });

    return modifiedText; // Returnează textul modificat
  }


  highlightWordsGreen(text: string): string {
    let modifiedTextGreen = text;

    // Funcție care escape-uiește caracterele speciale dintr-o frază pentru expresia regulată
    const escapeRegExpGreen = (string: string) => {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
    };

    // Iterează prin frazele de subliniat și le înlocuiește în text
    this.phrasesToHighlightGreen.forEach(phrase => {
      const escapedPhraseGreen = escapeRegExpGreen(phrase); // Escape the phrase
      const regex = new RegExp(`(${escapedPhraseGreen})`, 'gi'); // Căutăm fraza indiferent de majuscule/minuscule
      modifiedTextGreen = modifiedTextGreen.replace(regex, `<span class="highlight-text">$1</span>`); // Aplică clasa CSS pentru evidențiere
    });
    // console.log("cevaaaaaaaaaaaa:", modifiedTextGreen)
    return modifiedTextGreen; // Returnează textul modificat
  }

  applyHighlights(text: string): string {
    let modifiedText = this.highlightWords(text);

    modifiedText = this.highlightWordsGreen(modifiedText);

    return modifiedText;
  }


  ngAfterViewInit(): void {
    // Obține toate elementele cu clasa highlight-text
    const highlightedElements = document.querySelectorAll('.highlight-text');

    // Aici verificăm fiecare element și aplicăm stilurile dorite
    highlightedElements.forEach((element) => {
      if (element instanceof HTMLElement) { // Verificăm că elementul este de tip HTMLElement
        // Aplicăm stiluri sau modificări
        // element.style.borderBottom = '3px solid green'; // Exemplu de stil pentru bordură
        element.style.backgroundColor = "lime"
        element.style.color = "black"
        element.style.fontWeight = "bold"
        element.style.padding = "2px 4px"
        element.style.borderRadius = "2px"
      }
    });

    const highlightedElements2 = document.querySelectorAll('.highlight-blue');

    // Aici verificăm fiecare element și aplicăm stilurile dorite
    highlightedElements2.forEach((element) => {
      if (element instanceof HTMLElement) { // Verificăm că elementul este de tip HTMLElement
        // Aplicăm stiluri sau modificări
        element.style.borderBottom = '3px solid blue'; // Exemplu de stil pentru bordură
      }
    });
  }

}







